import React from 'react';
import { Sparkles, Briefcase, Baby, Heart, TrendingUp, ArrowUpRight } from 'lucide-react';
import { services } from '../mock';

const iconMap = { Sparkles, Briefcase, Baby, Heart, TrendingUp };

const Services = () => {
  return (
    <section id="services" className="py-28 relative bg-[#faf7f0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <div className="ornament justify-center inline-flex mb-4">
            <span className="section-eyebrow">Our Practice</span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl text-[#1a1714]">
            Bespoke <span className="italic font-cormorant gold-text">consultations</span>
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-[#4a4035] text-[15px] font-light">
            Five sacred verticals — each tailored to the unique vibratory blueprint of your name, birth and intention.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, idx) => {
            const Icon = iconMap[s.icon] || Sparkles;
            return (
              <div key={s.id} className="card-luxe p-8 group">
                <div className="flex items-start justify-between mb-6">
                  <div className="w-14 h-14 flex items-center justify-center border border-[#c9a961]/50 rotate-45">
                    <Icon size={22} className="-rotate-45 text-[#a8842c]" />
                  </div>
                  <span className="font-display text-5xl text-[#e8d9a8] leading-none">0{idx + 1}</span>
                </div>
                <h3 className="font-display text-2xl text-[#1a1714] mb-4">{s.title}</h3>
                <ul className="space-y-2.5 mb-6">
                  {s.items.map((it) => (
                    <li key={it} className="flex items-start gap-2.5 text-[13.5px] text-[#4a4035] leading-relaxed">
                      <span className="divider-mark mt-2 shrink-0" />
                      <span>{it}</span>
                    </li>
                  ))}
                </ul>
                <a href="#contact" className="inline-flex items-center gap-2 text-[11px] tracking-[0.3em] uppercase text-[#a8842c] hover:text-[#1a1714] transition-colors duration-300">
                  Know more <ArrowUpRight size={14} />
                </a>
              </div>
            );
          })}
          {/* Decorative trailing card */}
          <div className="hidden lg:flex items-center justify-center text-center p-8 border border-dashed border-[#c9a961]/50 bg-gradient-to-br from-[#faf7f0] to-[#f1ead8]">
            <div>
              <div className="font-display text-3xl gold-text mb-3">Custom</div>
              <p className="text-[13px] text-[#4a4035] mb-5 font-light">
                A concern beyond these five? We craft private sessions, retreats and corporate readings.
              </p>
              <a href="#contact" className="btn-outline-gold text-[10px]">Talk to us</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
